import { render, staticRenderFns } from "./NtkoSign.vue?vue&type=template&id=b647afee&scoped=true"
import script from "./NtkoSign.vue?vue&type=script&lang=ts"
export * from "./NtkoSign.vue?vue&type=script&lang=ts"
import style0 from "./NtkoSign.vue?vue&type=style&index=0&id=b647afee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b647afee",
  null
  
)

export default component.exports